import { render, staticRenderFns } from "./staffwithdrawal.vue?vue&type=template&id=dc19414a&scoped=true"
import script from "./staffwithdrawal.vue?vue&type=script&lang=js"
export * from "./staffwithdrawal.vue?vue&type=script&lang=js"
import style0 from "./staffwithdrawal.vue?vue&type=style&index=0&id=dc19414a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc19414a",
  null
  
)

export default component.exports